module.exports = __webpack_public_path__ + "cooking-class.38dbee83.jpg";